import {
  Box,
  Flex,
  VStack,
  SimpleGrid,
  Text,
  Input,
  InputGroup,
  Img,
  Button,
  useTheme,
} from "@chakra-ui/react";
import { useState } from "react";

const SERVER = import.meta.env.VITE_API_URL;

const Signin = () => {
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const setTokenCookie = (token) => {
    document.cookie = `prima_session=${token}; path=/; SameSite=Strict`;
  };

  const handleSignInSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await fetch(`${SERVER}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Ensure token is stored cleanly without extra quotes or whitespace
        const cleanToken =
          typeof data.token === "string" ? data.token.trim() : data.token;
        localStorage.setItem("prima_session", cleanToken);

        // Cache user data if available
        if (data.data) {
          localStorage.setItem("prima_user", JSON.stringify(data.data));
        }

        setTokenCookie(cleanToken);
        window.location.reload();
      } else {
        setError(data.error || "Invalid email or password");
      }
    } catch (err) {
      console.error("Error during login:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex
      h={"100vh"}
      flexDirection={["column", "column", "row", "row"]}
      w={"100%"}
    >
      {/* Left VStack */}
      <VStack w={["100%", "100%", "50%", "50%"]} h={"full"}>
        <SimpleGrid
          as="form"
          onSubmit={handleSignInSubmit}
          w={["100%", 400, "100%", 400]}
          gap={4}
          mt={["10vh", "10vh", "13vh", "13vh"]}
          p={6}
        >
          <Box textAlign={"center"} py={2}>
            <Img
              src="/loginSideImg.png"
              h={12}
              display={["block", "block", "none", "none"]}
              m={"auto"}
            />
            <Text
              fontSize={["20px", "24px", "28px", "32px"]}
              fontWeight={800}
              color={theme.colors.brand.accent}
            >
              Prima Travels
            </Text>
            <Text
              mt={0}
              pt={4}
              fontWeight={500}
              fontSize={["24px", "28px", "32px", "35px"]}
              color={theme.colors.brand.text.primary}
            >
              Welcome Back
            </Text>
            <Text
              mt={0}
              p={0}
              fontWeight={500}
              fontSize={["12px", "14px", "14px", "16px"]}
              color={theme.colors.brand.text.secondary}
            >
              Enter the below field to login
            </Text>
          </Box>

          {error && (
            <Box
              padding={2}
              bgColor={"red"}
              textColor={"white"}
              fontWeight={500}
              borderRadius={5}
            >
              {error}
            </Box>
          )}

          <InputGroup>
            <Input
              variant={"outline"}
              size={"lg"}
              fontSize={["14px", "16px", "16px", "18px"]}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              borderRadius={0}
              required
            />
          </InputGroup>

          <InputGroup>
            <Input
              variant={"outline"}
              size={"lg"}
              fontSize={["14px", "16px", "16px", "18px"]}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              borderRadius={0}
              required
            />
          </InputGroup>

          <Button
            isLoading={isLoading}
            w={"full"}
            type="submit"
            size={"lg"}
            borderRadius={0}
            my={4}
          >
            Signin
          </Button>
        </SimpleGrid>
      </VStack>

      {/* Right VStack */}
      <VStack
        display={["none", "none", "flex", "flex"]}
        bgColor={"brand.accent"}
        justifyContent={"center"}
        bgImage={"/ridesyBg.png"}
        bgRepeat={"no-repeat"}
        bgSize={"cover"}
        h={"full"}
        w={["0%", "0%", "50%", "50%"]}
      >
        <Img src="/loginSideImg.png" w={"70%"} />
      </VStack>
    </Flex>
  );
};

export { Signin };
